import { FC } from 'react';
import { SCREENS } from 'src/constants/screens';
import Plate from 'src/view/components/Plate/Plate';
import PlatesSection from 'src/view/components/PlatesSection/PlatesSection';
import HeaderTitle from 'src/view/containers/Headers/components/HeaderTitle/HeaderTitle';
import Headers from 'src/view/containers/Headers/Headers';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { appStore } from 'src/mobx/appStore';
import './style.scss';

const SettingsScreen: FC = (): JSX.Element => {
  return (
    <div className="settings_screen">
      <Headers>
        <HeaderTitle title="Settings" />
      </Headers>
      <ScrollableBlock className="d-flex flex-column flex-grow-1" scrollClassName="pt-6 gap-30" showScrollbar scrollbarSize="normal">
        <PlatesSection title="general">
          <Plate title="Manage_users" path={SCREENS.SETTINGS_USERS()} />
          <Plate title="language_country_and_currency_section" path={SCREENS.SETTINGS_COUNTRIES()} />
        </PlatesSection>

        <PlatesSection title="ordering_channel">
          <Plate title="consumer_channel_configuration" path={SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG()} />
          <Plate title="website_info" path={SCREENS.SETTINGS_WEBSITE_ABOUT()} />
        </PlatesSection>

        <PlatesSection title="orders">
          <Plate title="Order_configuration" path={SCREENS.SETTINGS_ORDERS_CONDITIONS()} />
          <Plate title="preparation_settings_and_profiles" path={SCREENS.SETTINGS_PREPARATION_PROFILES()} />
          {appStore.isAddonsAvailable.franchise ? <Plate title="franchise_management" path={SCREENS.SETTINGS_ORDERS_FRANCHISE()} /> : null}
        </PlatesSection>

        {appStore.isAddonsAvailable.webhook && (
          <PlatesSection title="connections">
            <Plate title="webhook" path={SCREENS.SETTINGS_WEBHOOK()} />
          </PlatesSection>
        )}

        <PlatesSection title="communication">
          <Plate title="notifications" path={SCREENS.SETTINGS_NOTIFICATIONS_ORDER_STATUS()} />
        </PlatesSection>

        {appStore.isAddonsAvailable.kiosk ? (
          <PlatesSection title="devices">
            <Plate title="kiosks" path={SCREENS.SETTINGS_DEVICES_KIOSKS()} />
          </PlatesSection>
        ) : null}

        <PlatesSection title="Integrations">
          <Plate title="Integrations" path={SCREENS.SETTINGS_INTEGRATIONS()} />
        </PlatesSection>
      </ScrollableBlock>
    </div>
  );
};

export default SettingsScreen;
